import { FiltersDto } from '@features/activity/domain/filters.interface';
import { createAction, props } from '@ngrx/store';
import * as ActionTypes from './activity-payments-filters.actionTypes';

export const loadPaymentsFilters = createAction(ActionTypes.LOAD_PAYMENTS_FILTERS);
export const updatePaymentsFilters = createAction(ActionTypes.UPDATE_PAYMENTS_FILTERS, props<{ paymentsFilters: FiltersDto }>());
